import React, { useState } from 'react';
import {
  Box,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  TextField as Input,
  Typography,
} from '@mui/material';
import {
  Inbox as InboxIcon,
  ExpandMore as ExpandIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

// styles
import useStyles from './styles';
import useStyles2 from '../../styles';

// components
import Dot from '../Dot';
import { Button, Badge, Link as LinkMaterial } from '../../../Wrappers';

export default function SidebarLink({
  link,
  ext,
  icon,
  label,
  children,
  location,
  isSidebarOpened,
  nested,
  type,
  toggleDrawer,
  click,
  hidden,
  ...props
}) {
  // Helper function to check if any child link matches current location
  const hasActiveChild = (children, pathname) => {
    if (!children) return false;
    return children.some((child) => {
      if (child.link && (pathname === child.link || pathname.includes(child.link))) {
        return true;
      }
      if (child.children) {
        return hasActiveChild(child.children, pathname);
      }
      return false;
    });
  };

  // Check if this menu should be open by default
  // Open Real Estate Management (id: 0.5) by default, or if any child is active
  const shouldBeOpenByDefault = props.id === 0.5 || (children && hasActiveChild(children, location.pathname));

  // local
  let [isOpen, setIsOpen] = useState(shouldBeOpenByDefault);
  // Add Section Popover state
  const [anchorEl, setAnchorEl] = React.useState(null);

  // Login page onClick
  function onLogin() {
    localStorage.removeItem('token');
    window.location.reload();
  }

  onLogin.clickName = 'onLogin';

  let classes = useStyles(isOpen);
  const classes2 = useStyles2();
  if (hidden) return null;
  let isLinkActive =
    link && (location.pathname === link || location.pathname.includes(link));

  if (type === 'title')
    return (
      <Typography
        className={classnames(classes.linkText, classes.sectionTitle, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
      >
        {label}
      </Typography>
    );

  if (type === 'heading')
    return (
      <Typography
        className={classnames(classes.linkText, {
          [classes.linkTextHidden]: !isSidebarOpened,
        })}
        style={{
          color: '#000000',
          fontWeight: 'bold',
          fontSize: '14px',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          marginTop: '20px',
          marginBottom: '10px',
          paddingLeft: '16px',
          ...props.style
        }}
      >
        {label}
      </Typography>
    );

  if (type === 'divider') return <Divider className={classes.divider} />;

  if (type === 'margin') return <section style={{ marginTop: 240 }} />;

  // Add Section Popover

  const open = Boolean(anchorEl);
  const id = open ? 'add-section-popover' : undefined;

  function addSectionClick(event) {
    setAnchorEl(event.currentTarget);
  }

  addSectionClick.clickName = 'addSectionClick';

  const addSectionClose = () => {
    setAnchorEl(null);
  };

  if (!children && ext)
    return (
      <>
        <ListItem
          onClick={(e) => {
            if (click) {
              return click(e, addSectionClick, onLogin);
            }
            return toggleDrawer(e);
          }}
          onKeyPress={toggleDrawer}
          component={link ? LinkMaterial : null}
          href={link}
          className={classes.link}
          classes={{
            root: classnames(classes.link, {
              [classes.linkActive]: isLinkActive && !nested,
              [classes.linkNested]: nested,
            }),
          }}
        >
          {nested ? (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
              style={{ margin: -11 }}
            >
              <Dot color={isLinkActive && 'primary'} />
            </ListItemIcon>
          ) : (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={label}
          />
        </ListItem>
      </>
    );
  if (!children)
    return (
      <>
        <ListItem
          onClick={(e) => {
            if (click) {
              return click(e, addSectionClick, onLogin);
            }
            return toggleDrawer(e);
          }}
          onKeyPress={toggleDrawer}
          component={link ? Link : null}
          to={link}
          className={classes.link}
          classes={{
            root: classnames(classes.link, {
              [classes.linkActive]: isLinkActive && !nested,
              [classes.linkNested]: nested,
            }),
          }}
          style={nested && icon ? { paddingLeft: '14px' } : {}}
          button
        >
          {nested && !icon ? (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
              style={{ margin: -11 }}
            >
              <Dot color={isLinkActive && 'primary'} />
            </ListItemIcon>
          ) : (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
              sx={{
                minWidth: 40,
                display: 'flex !important',
                alignItems: 'center',
                justifyContent: 'center',
                visibility: 'visible !important',
                opacity: '1 !important',
                '& svg': {
                  display: 'block !important',
                  fontSize: '24px !important',
                  visibility: 'visible !important',
                  opacity: '1 !important',
                  width: '24px !important',
                  height: '24px !important',
                  color: 'inherit !important'
                }
              }}
            >
              {React.isValidElement(icon) ? icon : (icon ? React.createElement(icon) : <InboxIcon />)}
            </ListItemIcon>
          )}
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={label}
          />
        </ListItem>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={addSectionClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          classes={{ paper: classes2.popover }}
        >
          <Box m={3} display='flex' flexDirection='column'>
            <Typography>Add section</Typography>
            <Input
              placeholder='Section Name'
              classes={{ root: classes2.input }}
            />
            <Box display='flex' justifyContent='flex-end' mt={2}>
              <Button
                color='secondary'
                variant='contained'
                className={classes2.noBoxShadow}
              >
                Add
              </Button>
              <Button
                classes={{ label: classes2.buttonLabel }}
                onClick={addSectionClose}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Popover>
      </>
    );

  return (
    <>
      {props.badge ? (
        <ListItem
          button
          component={link && Link}
          onClick={toggleCollapse}
          className={classnames(classes.link, {
            [classes.linkActive]: isLinkActive,
            [classes.nestedMenu]: type === 'nested',
          })}
          style={!icon && children ? {
            backgroundColor: '#fff',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          } : {}}
          to={link}
          disableRipple
        >
          {children && !icon && (
            <ExpandIcon
              className={classnames(
                {
                  [classes.linkTextHidden]: !isSidebarOpened,
                },
              )}
              style={{
                marginRight: 8,
                marginLeft: 0,
                color: '#424242',
                transition: 'transform 0.3s',
                display: 'inline-flex',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          )}
          {icon && (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
              sx={{
                minWidth: 40,
                display: 'flex !important',
                alignItems: 'center',
                justifyContent: 'center',
                visibility: 'visible !important',
                opacity: '1 !important',
                '& svg': {
                  fontSize: '24px !important',
                  display: 'block !important',
                  visibility: 'visible !important',
                  opacity: '1 !important'
                }
              }}
            >
              {icon}
            </ListItemIcon>
          )}
          <Badge badgeContent={props.badge} color={props.badgeColor}>
            <ListItemText
              classes={{
                primary: classnames(classes.linkText, {
                  [classes.linkTextActive]: isLinkActive,
                  [classes.linkTextHidden]: !isSidebarOpened,
                }),
              }}
              primary={label}
            />
          </Badge>
          {children && icon && (
            <ExpandIcon
              className={classnames(
                {
                  [classes.expand]: isOpen,
                  [classes.linkTextHidden]: !isSidebarOpened,
                },
                classes.expandWrapper,
              )}
            />
          )}
        </ListItem>
      ) : (
        <ListItem
          button
          component={link && Link}
          onClick={toggleCollapse}
          className={classnames(classes.link, {
            [classes.linkActive]: isLinkActive,
            [classes.nestedMenu]: type === 'nested',
          })}
          style={!icon && children ? {
            backgroundColor: '#f5f5f5',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          } : {}}
          to={link}
          disableRipple
        >
          {children && !icon && (
            <ExpandIcon
              className={classnames(
                {
                  [classes.linkTextHidden]: !isSidebarOpened,
                },
              )}
              style={{
                marginRight: 8,
                marginLeft: 0,
                color: '#424242',
                transition: 'transform 0.3s',
                display: 'inline-flex',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          )}
          {icon && (
            <ListItemIcon
              className={classnames(classes.linkIcon, {
                [classes.linkIconActive]: isLinkActive,
              })}
              sx={{
                minWidth: 40,
                display: 'flex !important',
                alignItems: 'center',
                justifyContent: 'center',
                visibility: 'visible !important',
                opacity: '1 !important',
                '& svg': {
                  fontSize: '24px !important',
                  display: 'block !important',
                  visibility: 'visible !important',
                  opacity: '1 !important'
                }
              }}
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            classes={{
              primary: classnames(classes.linkText, {
                [classes.linkTextActive]: isLinkActive,
                [classes.linkTextHidden]: !isSidebarOpened,
              }),
            }}
            primary={label}
          />
          {children && icon && (
            <ExpandIcon
              className={classnames(
                {
                  [classes.expand]: isOpen,
                  [classes.linkTextHidden]: !isSidebarOpened,
                },
                classes.expandWrapper,
              )}
            />
          )}
        </ListItem>
      )}
      {children && (
        <Collapse
          in={isOpen && isSidebarOpened}
          timeout='auto'
          unmountOnExit
          className={classnames(classes.nestedList, {
            [classes.nestedMenuItem]: type === 'nested',
          })}
        >
          <List component='div' disablePadding>
            {children.map((childrenLink) => (
              <SidebarLink
                key={(childrenLink && childrenLink.link) || childrenLink.label}
                location={location}
                isSidebarOpened={isSidebarOpened}
                classes={classes}
                toggleDrawer={toggleDrawer}
                nested
                {...childrenLink}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );

  // ###########################################################

  function toggleCollapse(e) {
    if (isSidebarOpened) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  }
}
